<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Therapist Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="tab-pane1">
                            <div class="sec_head_new sec_head_new_after">
                                <form [formGroup]="searchForm">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="filter_search mb20 width100">
                                                <div class="input-group filter_search_group">
                                                    <input type="text" class="form-control overflow-text"
                                                        formControlName="search" placeholder="Search by therapist name"
                                                        maxlength="60">
                                                    <div class="input-group-append">
                                                        <button class="btn btn_search_group" type="button">
                                                            <img src="assets/img/icon-search.png" alt="Search" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">

                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group row d-flex justify-content-end">
                                                <div class="ms-5 text-align-end text-nowrap" style="text-align: end">
                                                    <button type="button" routerLink="/add-therapist"
                                                        class="btn btn-info link font17"
                                                        style="height: 35px;padding-top: 3px;">
                                                        <i class="fa fa-plus-circle" aria-hidden="true"> Add New </i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>From date:</mat-label>
                                                <input matInput [max]="maxDate" id="fromDate" [matDatepicker]="picker"
                                                    formControlName="fromDate">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="fromDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="fromDate"> -->
                                        </div>
                                        <div class="col-md-2">
                                            <mat-form-field appearance="fill" class="width-webkit-fill-available">
                                                <mat-label>To Date :</mat-label>
                                                <input matInput [max]="maxDate" id="toDate" [matDatepicker]="picker1"
                                                    formControlName="toDate">
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="picker1"></mat-datepicker-toggle>
                                                <mat-datepicker #picker1></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <input type="date" id="toDate" style="border-radius: 5px;max-width: 200px" class="form-control" formControlName="toDate"> -->

                                        </div>
                                        <div class="col-md-8">
                                            <button type="button" class="btn btn-info"
                                                (click)="getTherapistList(currentPage)"
                                                style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-search"> Search </i>
                                            </button>

                                            <button class="btn btn-danger ms-2" type="button" (click)="Reset()"
                                                style="height: 35px;padding-top: 3px;">
                                                <i class="fa fa-undo"> Reset</i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered" aria-describedby="">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img" scope="col">S.No.</th>
                                        <th scope="col" class="Sorting-img">Therapist name</th>
                                        <th scope="col" class="Sorting-img">Email address</th>
                                        <th scope="col" class="Sorting-img">Specialty</th>
                                        <th scope="col" class="Sorting-img">Type</th>
                                        <th scope="col" class="Sorting-img">Date Of Joining</th>
                                        <th scope="col" class="Sorting-img">Assigned to</th>
                                        <th scope="col" class="Sorting-img">Availability</th>
                                        <th scope="col" class="action_td_btn3 Sorting-img">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (therapy of therapistList| paginate: { itemsPerPage: itemPerPage, currentPage:
                                    currentPage, totalItems: total}; track therapy; let i = $index) {
                                    <tr class="text-center">
                                        <td>{{itemPerPage * (currentPage -1 ) + i+1}}</td>
                                        <td class="content">
                                            {{therapy?.firstName}}
                                            @if(therapy?.lastName){
                                            <span>{{therapy?.lastName}}</span>
                                            }
                                        </td>
                                        <td class="content">
                                            <abbr [title]="therapy?.email">
                                                {{therapy?.email}}
                                            </abbr>
                                        </td>
                                        <td class="content">{{therapy?.speciality}}</td>
                                        <td class="content">{{therapy?.role}}</td>
                                        <td class="content">{{therapy?.createdAt | date : 'd/M/y' :'UTC'}}</td>
                                        <td class="content">
                                            @if(therapy?.myPatient.length){
                                            <div class="d-flex w-100" style="max-width: 150px;
                                            min-width: 75px;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            overflow: hidden;">
                                                @for (patientName of therapy?.myPatient; track patientName; let i =
                                                $index) {
                                                <label class="font15 me-3" style="max-width: 150px;
                                                min-width: 75px;
                                                text-overflow: ellipsis;
                                                white-space: nowrap;
                                                overflow: hidden;">
                                                    <abbr [title]="patientName?.firstName">
                                                        {{patientName?.firstName }} {{patientName?.lastName}} ,
                                                    </abbr>
                                                </label>
                                                }
                                            </div>
                                            }
                                            @if(!therapy?.myPatient.length){
                                            <span>--</span>
                                            }
                                        </td>
                                        <td class="content">
                                            <a target="_blank" style="cursor: pointer"
                                                (click)="getSlotofTherapistApi(therapy?._id,therapy?.timeZone,therapy?.firstName,therapy?.lastName)"
                                                class="font17" rel="noopener noreferrer">
                                                Check Calendar
                                            </a>
                                        </td>
                                        <td class="text-center action_td">
                                            <button class="btn btn-info ms-2 bt-margin" title="view"
                                                [routerLink]="['/view-therapist/'+ (therapy?._id)]">
                                                <i class="fa fa-eye" style="color:white"></i></button>
                                            <button class="btn btn-info ms-2 bt-margin"
                                                [routerLink]="['/edit-therapist/'+ (therapy?._id)]"><i
                                                    class="fa fa-edit" style="color:white"></i></button>

                                            <label class="switch"
                                                (click)="openActiveBlock(therapy?.status ,therapy?._id)">
                                                <input type="checkbox"
                                                    [checked]="(therapy?.status == 'ACTIVE') || (therapy?.data?.status == 'ACTIVE')">
                                                <span class="slider round"></span>
                                            </label>
                                            <button class="btn btn-danger ms-3 me-2 bt-margin" title="delete"
                                                (click)="deleteUserModal(therapy?._id)"><i class="fa fa-trash"
                                                    style="color:white"></i></button>
                                        </td>
                                    </tr>
                                    }

                                    @if(!therapistList.length){
                                    <tr>
                                        <td class="table-no-record" colspan="9">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            @if(total > 10){
                            <div class="custom-pagination mt-3 d-flex justify-content-end">
                                <pagination-controls (pageChange)="getTherapistList($event)"></pagination-controls>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteUser">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Therapist?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this Therapist?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="deleteTherapist()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->

<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="actBlockStatus">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    @if(therapyStatus == 'ACTIVE'){
                    <h5 class="modal-title d-inline-block">Block Therapist?</h5>
                    } @else if(therapyStatus == 'BLOCK') {
                    <h5 class="modal-title d-inline-block"> Active Therapist?</h5>
                    }
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                @if(therapyStatus == 'ACTIVE'){
                                <p>Are you sure you want to block this Therapist?</p>
                                } @else if(therapyStatus == 'BLOCK') {
                                <p>Are you sure you want to Active this Therapist?</p>
                                }
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="updateActiveBlock()"
                                        data-dismiss="modal">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->


<!-- *************************Therapist Calendar start here ******************************** -->
<div class="modal fade global-modal reset-modal" id="therapistCalender">
    <div class="modal-dialog max-WT-1000">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-inner-content">
                    <div class="modal-body modal-height">
                        <div class="row d-flex justify-content-end">
                            <div class="text-right align-items-center d-flex ">
                                <label class="bookedSessions"></label>
                                <label class="ms-1 text-nowrap">Booked slot</label>
                                <label class="Sessions ms-3"></label>
                                <label class="ms-1 text-nowrap">Available slot</label>
                                <label class="UnavailableSessions ms-3"></label>
                                <label class="ms-1 text-nowrap">Unavailable slot</label>
                                <label class="btn-close" data-dismiss="modal" aria-label="Close">
                                    <i class="fa fa-times cross" data-dismiss="modal" aria-hidden="true"></i>
                                </label>
                            </div>
                        </div>

                        <div class="m-3">
                            <h5 class="text-center">Mr. {{therapistFullName}}</h5>
                        </div>
                        <div class="table-responsive">
                            <div class="d-flex max-WT-550">
                                @for (day of weekDaysofTherapist; track day; let i = $index) {
                                <label class="ms-3 text-nowrap font14">
                                    <span [ngClass]="{active : (selectedDay == day?._id)}"
                                        (click)="dateChange(day?._id)">
                                        <!-- {{day?.scheduleDate | date : 'EEE,d MMM'}} -->
                                        {{day?.scheduleDate | date : 'EEE,d MMM' : 'UTC'}}
                                    </span>
                                    @for (time of day?.schedule; track time; let i = $index) {
                                    <p (click)="openBlockSlotModal(time?._id,time?.status)"
                                        class="border my-3 bg-gray font14 text-center"
                                        [ngStyle]="{'background-color' : time?.status === 'AVAILABLE' ? '#28a745' :  time?.status === 'INACTIVE' ? 'orange': 'red' ,'color' : 'white'}"
                                        [ngClass]="{active : selectedDay == day?._id}">
                                        {{time?.startTime | convertDate: timeZone }}
                                    </p>
                                    }
                                </label>
                                }
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- *************************Therapist Calendar start here ******************************** -->

<!-- ----------------  Active and block patient modal ----------------------- -->

<div class="modal fade global-modal reset-modal" id="actBlockSlot">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    @if(slotStatus == 'AVAILABLE'){
                    <h5 class="modal-title d-inline-block">Block Slot?</h5>
                    } @else if(slotStatus == 'INACTIVE') {
                    <h5 class="modal-title d-inline-block"> Available Slot?</h5>
                    }
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                @if(slotStatus == 'AVAILABLE'){
                                <p>Are you sure you want to block this slot?</p>
                                } @else if(slotStatus == 'INACTIVE') {
                                <p>Are you sure you want to available this slot?</p>
                                }
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="blockSlotApi()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>